import { getRandomColor } from 'utils/get-random-color';
import { getUserLabel } from 'utils/get-user-label';
export const userOption = (user)=>{
    var _user_role, _user_company, _user_role1;
    return {
        label: getUserLabel(user),
        value: user.userId,
        imageUrl: user.photoUrl,
        description: (_user_role = user.role) === null || _user_role === void 0 ? void 0 : _user_role.roleName,
        logoUrl: (_user_company = user.company) === null || _user_company === void 0 ? void 0 : _user_company.companyLogoUrl,
        color: getRandomColor(user.userId),
        roleId: (_user_role1 = user.role) === null || _user_role1 === void 0 ? void 0 : _user_role1.roleId,
        emailId: user.emailId,
        userTimeOffDetails: user === null || user === void 0 ? void 0 : user.userTimeOffDetails,
        holidayCalendarId: user === null || user === void 0 ? void 0 : user.holidayCalendarId,
        userStatus: user.userStatus,
        extra: {
            id: user.userId,
            type: 'user',
            userType: user.userType,
            company: user.company,
            role: user.role
        }
    };
};
export const getUsersAsOptions = (users)=>{
    return users === null || users === void 0 ? void 0 : users.map((user)=>userOption(user));
};
